import Array from "./tableData";
import Matrix from "./matrix";
import Strings from "./strings";
import Search from "./search";
import LinkedList from "./linkedlist";
import BitManipulation from "./bitManipulation";
import BinaryTree from "./binarytree"
import Bst from "./bst";
import Greedy from "./greedy";
import BackTracking from "./backtracking";
import StackQueue from "./Stackqueue";
import Heap from "./heap";
import Graph from "./graph";
import Trie from "./trie";
import Dp from "./dp";

const cardData = [
    {
        id: 1,
        title: "Array",
        total: Array.length
    },
    {
        id: 2,
        title: "Matrix (2-D Array)",
        total: Matrix.length
    },
    {
        id: 3,
        title: "Strings",
        total: Strings.length
    },
    {
        id: 4,
        title: "Search & Sort",
        total: Search.length
    },
    {
        id: 5,
        title: "Linked Lists",
        total: LinkedList.length
    },
    {
        id: 6,
        title: "Binary Trees",
        total: BinaryTree.length
    },
    {
        id: 7,
        title: "BST",
        total: Bst.length
    },
    {
        id: 8,
        title: "Greedy",
        total: Greedy.length
    },
    {
        id: 9,
        title: "Backtracking",
        total: BackTracking.length
    },
    {
        id: 10,
        title: "Stacks & Queues",
        total: StackQueue.length
    },
    {
        id: 11,
        title: "Heap",
        total: Heap.length
    },
    {
        id: 12,
        title: "Graph",
        total: Graph.length
    },
    {
        id: 13,
        title: "Trie",
        total: Trie.length
    },
    {
        id: 14,
        title: "Dynamic Programming",
        total: Dp.length
    },
    {
        id: 15,
        title: "Bit Manipulation",
        total: BitManipulation.length
    }
]

export default cardData;